import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Link } from "react-router-dom";

const Container = tw.div`mb-16 border-t-2 pt-10`;
const Header = tw.div`flex justify-between items-end mb-6`;
const Heading = tw.h2`text-2xl font-bold text-gray-900`;
const Subheading = tw.p`text-gray-500 text-sm mt-1`;
const CardsGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6`;

const CardContainer = styled(Link)`
  ${tw`relative overflow-hidden bg-white p-6 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100`}
  animation-delay: ${({ delay }) => delay};
  ${tw`animate-none`}

  &:hover {
    text-decoration: none;
  }
`;

const CardBackground = styled.div`
  ${tw`absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 rounded-full opacity-10`}
  ${({ colorClass }) => colorClass}
`;

const CardContent = tw.div`relative z-10 flex flex-col h-full`;

const CardIconContainer = styled.div`
  ${tw`w-12 h-12 rounded-lg flex items-center justify-center text-2xl mb-4 bg-opacity-10 text-opacity-100`}
  ${({ colorClass }) => colorClass}
`;

const CardTitle = tw.h3`text-xl font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors`;
const CardDescription = tw.p`text-gray-500 text-sm grow leading-relaxed`;
const CardAction = tw.div`mt-4 flex items-center text-sm font-semibold text-primary-600  opacity-0 group-hover:opacity-100 transition-opacity transform translate-y-2 group-hover:translate-y-0`;
const ActionText = tw.span`ml-1`;

const DashboardCard = ({ to, title, description, icon, colorClass, delay }) => (
  <CardContainer to={to} delay={delay}>
    <CardBackground colorClass={colorClass} />
    <CardContent>
      <CardIconContainer colorClass={colorClass}>{icon}</CardIconContainer>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
      <CardAction>
        Explore <ActionText>→</ActionText>
      </CardAction>
    </CardContent>
  </CardContainer>
);

export default function DashboardGrid() {
  return (
    <Container>
      <Header>
        <div>
          <Heading>Dashboard</Heading>
          <Subheading>Quick access to student and faculty services</Subheading>
        </div>
      </Header>
      <CardsGrid>
        <DashboardCard
          to="/donation"
          title="Donations"
          description="Securely contribute to the institution's growth and welfare."
          icon="🤝"
          colorClass={tw`bg-green-500 text-green-600`}
          delay="0s"
        />
        <DashboardCard
          to="/magazine"
          title="Digital Library"
          description="Access Salsabeel, Ar-Rushd magazines and research papers."
          icon="📖"
          colorClass={tw`bg-primary-100 text-primary-600`}
          delay="0.1s"
        />
        <DashboardCard
          to="/events"
          title="Events & News"
          description="Stay updated with upcoming seminars, exams, and holidays."
          icon="📢"
          colorClass={tw`bg-purple-500 text-purple-600`}
          delay="0.2s"
        />
        <DashboardCard
          to="/photo-gallery"
          title="Photo Gallery"
          description="Explore our photo collections and memorable moments."
          icon="🖼️"
          colorClass={tw`bg-orange-500 text-orange-600`}
          delay="0.3s"
        />
      </CardsGrid>
    </Container>
  );
}
